export const COM_RELOAD_USERINFO = 'COM_RELOAD_USERINFO';
export const COM_SET_BREADCRUMB = 'COM_SET_BREADCRUMB';
